export { default } from "./BasicConfig";
